import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  FIND_USER_SUBPASS,
  RESET_SUBPASS,
  M_POST,
  FETCH_RESET_LOG,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'secure' })
export default class Secure extends VuexModule {
  listSecureCode: any = [];

  @Mutation
  mutateSecureCode(secureCode) {
    this.listSecureCode = secureCode;
  }

  @Action({ commit: 'mutateSecureCode' })
  FetchSecureCode(params = {}) {
    return Vue.axios({
      url: BASE_URL + FIND_USER_SUBPASS,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  ResetSecureCode(params) {
    return Vue.axios({
      url: BASE_URL + RESET_SUBPASS,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }

  @Action
  FecthResetSubPassLog(username) {
    return Vue.axios({
      url: BASE_URL + FETCH_RESET_LOG,
      method: M_POST,
      data: username,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }
}
